/**
 * Keep burger aria-expanded in sync when the full main bundle toggles
 * body.is-head-open (shared-theme-assets burger handler).
 */
(function () {
    'use strict';

    function syncBurger() {
        var burger = document.querySelector('.gh-burger');
        var head = document.getElementById('gh-head');
        var open = document.body.classList.contains('is-head-open');
        if (burger) {
            burger.setAttribute('aria-expanded', open ? 'true' : 'false');
        }
        if (head) {
            if (open) {
                head.setAttribute('tabindex', '0');
            } else {
                head.removeAttribute('tabindex');
            }
        }
    }

    function init() {
        syncBurger();
        var observer = new MutationObserver(syncBurger);
        observer.observe(document.body, {attributes: true, attributeFilter: ['class']});
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
